import { render, staticRenderFns } from "./Schlauchannahme.vue?vue&type=template&id=5734a860&"
import script from "./Schlauchannahme.vue?vue&type=script&lang=js&"
export * from "./Schlauchannahme.vue?vue&type=script&lang=js&"
import style0 from "./Schlauchannahme.vue?vue&type=style&index=0&id=5734a860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports